import BaseServiceCrud from './BaseServiceCrud';

export default class CardOrderService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'card-order';
    }

    getCriteria() {
        return this.objToQueryString({});
    }

    saveAsTemplate(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/save-as-template`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
